var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.showSpinner}},[(_vm.showSpinner)?_c('BSpinner',{staticClass:"mx-1",attrs:{"small":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }